import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "combine_cells",
  "use": "combine_cells-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"combine_cells\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23 0a1 1 0 011 1v22a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h22zm-2 2a1 1 0 011 1v18a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h18zm-9 1a1 1 0 00-1 1v2a1 1 0 102 0V4a1 1 0 00-1-1zm-1 8a1 1 0 112 0v2a1 1 0 11-2 0v-2zm1 6a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol